import { render, staticRenderFns } from "./Juncao.vue?vue&type=template&id=62b7f81f&"
import script from "./Juncao.vue?vue&type=script&lang=js&"
export * from "./Juncao.vue?vue&type=script&lang=js&"
import style0 from "./Juncao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports